import { IRect } from '../imports/utils';

export const defaultCropRectRelative = IRect({
  width: 1,
  height: 1,
  top: 0,
  left: 0
});
